import { LocaleEnum } from '@systemeio/ui-frontend'
import { httpClient } from './http-client'

export function changeLanguage(locale: LocaleEnum): Promise<void> {
  return httpClient.post('/api/user/change-language', { language: locale })
}
